import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { EditableTableService } from './service/editable-table.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
	selector: 'cv-editable-table',
	templateUrl: 'editable-table.component.html',
	styleUrls: ['./editable-table.component.scss'],
	providers: [ConfirmationService, MessageService]
})
export class EditableTableComponent implements OnInit, OnDestroy {
	public label = '';
	private atComponentDestroy: Subject<any> = new Subject<any>();
	public model: Array<any>;
	public defaultModel : any = {
		disabled: false,
		getValue: (field: any, row: any) => {
			return row[field.key];
		}
	}
	public data: any = [];
	clonedData: any = [];

	constructor(
		public confirmationService: ConfirmationService,
		public messageService: MessageService,
		protected service: EditableTableService) {
	}

	ngOnInit() {
		this.model = this.model.map((tmpModel) => {
			return {...this.defaultModel, ...tmpModel}
		});

		this.loadData();
	}

	onChange($event: any, field: any, row: any): void {
		if (field.onChange) {
			field.onChange($event, row);
		}
	}

	getCellWidth(): any {
		return 100 / (this.model.length + 1);
	}

	loadData() {
		this.service
			.getData()
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				this.data = result.data ? result.data : result;

				this.data = this.data.map((row: any, index: any) => {
					return { ...{id: index}, ...row}
				});
			});
	}

	onRowEditInit(row: any) {
		this.clonedData[row.id] = { ...row };
	}

	onRowEditSave(row: any): void {
		this.data[row.id] = { ...row };

		delete this.clonedData[row.id];

		this.service
			.saveData(this.data)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				this.messageService.add({ severity: 'success', summary: 'Success', detail: `${this.label} was updated` });
			}, error => {
				console.error(error);
			});
	}

	onShowDeleteConfirm(row: any) {
		this.confirmationService.confirm({
			message: 'Are you sure that you want to proceed?',
			header: 'Confirmation',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.deleteRow(row);
			},
			// reject: () => {
			// }
		});
	}

	deleteRow(row: any) {
		this.data = this.data.filter((item: { id: any; }) => item.id !== row.id);

		this.service
			.saveData(this.data)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Product Type was deleted' });
			}, error => {
				console.error(error);
			});
	}

	onRowEditCancel(row: any, index: number) {
		this.data[index] = this.clonedData[row.id];
		delete this.clonedData[row.id];
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
